export const getSelfRetweetsCount = (tweetObjects) => {
    return tweetObjects.filter(tweetObject => isSelfRetweet(tweetObject)).length;
}

export const isSelfRetweet = (tweetObject) => {
    return tweetObject.OriginalTweet !== null && tweetObject.OriginalTweet !== undefined && tweetObject.TweetedBy === tweetObject.OriginalTweet.TweetedBy;
}